<div class="visible-lg">
  <div class="flex-container">
    <div class="bmw-bulletin-container flex-60">
      <div class="bmw-bulletin-title">
        Add New Bulletin
      </div>
      <div class="cms-modal-select-make-checkbox">
        <label class="container sm">SIB
          <input type="radio" name="sib" value="sib" [(ngModel)]='bulletinType'>
          <span class="checkmark"></span>
        </label>
       
        <label class="container sm" style="margin-right:0em;width:10em">PBS
          <input type="radio" name="pbs" value="pbs" [(ngModel)]='bulletinType'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="cms-modal-select-make-checkbox">
        <label class="container" *ngFor='let make of makeList'>{{make?.makeName}}
          <input type="radio" name="radio" [value]="make" [(ngModel)]='inputMake'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div>
        <label>Password</label>
        <div style="width: 200px;margin-bottom: 20px;">
          <input [(ngModel)]='adminPassword' type="password" name="password" id="password">
        </div>
      </div>
      <div>
        <label>Main Group</label>
        <div class="bmw-cms-new-bulletin-select">
          <select class="form-control" id="group" [(ngModel)]='inputGroup'>
            <option [ngValue]="undefined" disabled selected> Select Main Group </option>
            <option *ngFor="let group of mainGroupList" [ngValue]="group">{{group}}</option>
          </select>
        </div>
        <label>Description</label>
        <div class="bmw-cms-new-bulletin-select">
          <textarea [(ngModel)]='description' placeholder="Enter description"></textarea>
        </div>
        <div>
          <label>Bulletin Number</label>
          <div style="width: 200px">
            <input type="text" name="bulletinNumber" maxlength="8" placeholder="00 00 00" [(ngModel)]="bulletinNumber" required (keyup)="formatBulletinNumber($event)">
          </div>
        </div>
        <div class="flex-container">
          <div class="flex-35">
            <label class="container is-takata-recall">Is Takata Recall?
              <input type="checkbox" name="chechbox" value='isTakataRecall' [(ngModel)]='isTakataRecall'>
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="flex-50">
            <label>Takata Recall Code</label>
            <div>
              <input type="text" name="tkr" [disabled]='!isTakataRecall' placeholder="ex 14V-428" [(ngModel)]="tkrCode" required>
            </div>
          </div>
        </div>
        <div style="margin-top: 15px" class="flex-container">
          <label>Date</label>
          <div>
            <input type="date" name="mydate"  [(ngModel)]="inputDate" class="form-control" required />
          </div>
        </div>
        <div style="margin-top: 25px">
          <small>Supporting Files and Images</small>
        </div>
        <div class="bmw-cms-modal-button">
          <div class="upload-btn-wrapper flex-150-px">
            <button class="btn pointer" [disabled]='this.bulletinType === "pbs"'>Choose File</button>
            <input type="file" multiple name="myfiles" (change)='fileUploadSupporting($event)' />
          </div>
          <div *ngIf="uploadedSupportingFileNames?.length === 0; then thenBlock else elseBlock"></div>
          <ng-template #thenBlock>
            <div class="bmw-bulletin-nofile-label flex">No File Choosen</div>
          </ng-template>
          <ng-template #elseBlock>
            <div>
              <div class="bmw-bulletin-nofile-label" *ngFor='let fileName of uploadedSupportingFileNames'>{{fileName}}</div>
            </div>
          </ng-template>
        </div>
        <div style="margin-top: 25px">
          <small>Arbortext XML/Parts Bulletin PDF File</small>
        </div>
        <div class="bmw-cms-modal-button">
          <div class="upload-btn-wrapper file2 flex-150-px">
            <button class="btn pointer">Choose File</button>
            <input type="file" name="myfile" (change)='fileUpload($event)' />
          </div>
          <div class="bmw-bulletin-nofile-label flex">{{uploadedFileName}}</div>
        </div>

        <div class="bmw-cms-modal-button new-bulletin">
          <button [disabled]='!inputMake || !bulletinType || !adminPassword' class="bmw-button-secondary" (click)='submitBulletin()'>Submit</button>
        </div>
        <small style="color: red">{{errorMessage}}</small>
      </div>
    </div>
  </div>
</div>